/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GeoLocationEventResponseModel { 
    customerOrderId?: number;
    userName?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    readonly userNameDisplay?: string | null;
    userNameDetails?: string | null;
    customerOrderNumber?: string | null;
    customerOrderLatitude?: string | null;
    customerOrderLongitude?: string | null;
    salesLatitude?: string | null;
    salesLongitude?: string | null;
    customerNumber?: string | null;
    customerName?: string | null;
    customerAddress1?: string | null;
    customerAddress2?: string | null;
    customerCity?: string | null;
    customerState?: string | null;
    customerZipCode?: string | null;
    customerDetails?: string | null;
    customerAddressLatitude?: string | null;
    customerAddressLongitude?: string | null;
    geoLocationTimeStamp?: string;
}

